/**
 * Created by xuyq on 2021/1/22.
 */
import Vue from 'vue'

import enLocale from './en'
import zhLocale from './zh'

import zh_vuetify from 'vuetify/es5/locale/zh-Hans'
import en_vuetify from 'vuetify/es5/locale/en'
import {settings,loadLanguage,i18n,} from "@/myops/core";


const locale = localStorage.getItem('language') || (settings||{lang:'zh'}).lang

let messages = {
    en: {
        ...enLocale,
        $vuetify: {
            ...en_vuetify
        }
    },
    zh: {
        ...zhLocale,
        $vuetify: {
            ...zh_vuetify
        }
    }
}
for(let key of Object.keys(messages)){
    loadLanguage(key,messages[key])
}

i18n.locale = locale

i18n.mergeMessage = function({zh, en} = {}) {
    i18n.mergeLocaleMessage('zh', zh)
    i18n.mergeLocaleMessage('en', en)
}

i18n.switch = function(locale) {
    localStorage.setItem('language', locale)
    window.location.reload()
}




export default i18n
